import React from 'react';
import {
    toFixedTrunc,
    getStatus,
    getCryptoStatus,
    getCurrencySymbol,
} from '../../../client/Juno/helpers';
import { statusStyle } from '../../helpers/constant';
import { format } from 'date-fns';
import { cryptoTransactions, fiatTransactions } from '../../helpers/constant';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { SendIcon } from '../../utils/Images';

const TransactionListItem = ({ transaction }) => {
    const depositAmount =
        transaction.type === 'Deposit' &&
        transaction.transactionDetails[0].amount - transaction.transactionFee;
    const statusText =
        transaction?.currencyType === 'fiat'
            ? getStatus(transaction?.status?.code, transaction?.type)
            : getCryptoStatus(transaction?.status?.code, transaction?.status?.message);
    const statusKey = statusText.toUpperCase().replace('/', '');
    const activeCurrencyPage = localStorage.getItem('activeCurrencyPage');

    const transactionsLogo = [...fiatTransactions, ...cryptoTransactions].map(transaction => {
        const isBuyOrSell = ['buy', 'sell'].includes(transaction.label?.toLowerCase());

        if (isBuyOrSell && activeCurrencyPage === 'fiat') {
            return {
                ...transaction,
                icon: (
                    <img
                        src={`https://dev.junomoney.org/images${SendIcon}`}
                        alt={`${transaction.label} Icon`}
                        className="w-5 h-5 filter dark:invert dark:brightness-0 dark:contrast-200 transition-all"
                    />
                ),
            };
        }

        return transaction;
    });

    return (
        <div>
            <div className="border-b-[1px] !border-secondary self-stretch h-20 w-full px-6 inline-flex justify-start items-center gap-4 overflow-hidden bg-filterPannel-bg rounded-md">
                <div className="w-11 h-10 md:h-11 relative !bg-secondary text-text rounded-full overflow-hidden flex justify-center items-center">
                    {
                        transactionsLogo.find(
                            transactionIcon =>
                                transactionIcon.type?.toLowerCase() ===
                                    transaction?.type?.toLowerCase() ||
                                transactionIcon.key?.toLowerCase() ===
                                    transaction?.type?.replace(/\s+/g, '')?.toLowerCase(),
                        )?.icon
                    }
                </div>
                <div className="flex w-full justify-between">
                    <div className="flex-1 inline-flex flex-col justify-center items-start gap-0.5">
                        <div className="justify-start text-balanceCard-manage text-sm font-medium ">
                            {format(transaction?.createdDate, 'dd.MM.yy HH:mm')}
                        </div>
                        <div className="justify-start !text-text text-sm font-semibold uppercase">
                            {activeCurrencyPage === 'fiat' && transaction?.type === 'Buy'
                                ? 'Transfer (Out)'
                                : activeCurrencyPage === 'fiat' && transaction?.type === 'Sell'
                                  ? 'Transfer (In)'
                                  : transaction?.type}
                        </div>
                    </div>
                    <div className="inline-flex flex-col justify-center items-end gap-0.5">
                        <span
                            className={`px-2 py-1 text-xs font-semibold uppercase ${statusStyle[statusKey]}`}>
                            {statusText}
                        </span>
                        <div className="text-right justify-start !text-text text-sm font-semibold  ">
                            {transaction?.currencyType === 'fiat' ? (
                                <div>
                                    {transaction?.type === 'FX' && (
                                        <p className="jncTransactionsList__text !text-text t-right">
                                            {toFixedTrunc(
                                                transaction?.transactionDetails?.[0]?.fromAmount,
                                                2,
                                            )}{' '}
                                            {transaction?.currency ||
                                                transaction?.transactionDetails?.[0]?.fromCurrency}
                                            &ensp;-&ensp;
                                            {toFixedTrunc(
                                                transaction?.transactionDetails?.[0]?.toAmount,
                                                2,
                                            )}{' '}
                                            {transaction?.currency ||
                                                transaction?.transactionDetails?.[0]?.toCurrency}
                                        </p>
                                    )}
                                    {transaction?.type !== 'FX' && (
                                        <p className="jncTransactionsList__text !text-text t-right">
                                            {transaction?.type !== 'Deposit'
                                                ? toFixedTrunc(
                                                      transaction?.transactionDetails?.[0]?.amount,
                                                      2,
                                                  )
                                                : toFixedTrunc(depositAmount, 2)}{' '}
                                            {transaction?.currency ||
                                                transaction?.transactionDetails?.[0]?.currency}
                                        </p>
                                    )}
                                </div>
                            ) : (
                                <div>
                                    {transaction?.type === 'Exchange' && (
                                        <p className="jncTransactionsList__text !text-text t-right">
                                            {toFixedTrunc(
                                                transaction?.transactionDetails?.[0]
                                                    ?.fromCryptoAmount,
                                                6,
                                            )}{' '}
                                            {getCurrencySymbol(
                                                transaction?.currency ||
                                                    transaction?.transactionDetails?.[0]
                                                        ?.fromCryptoId,
                                            )}{' '}
                                            &ensp;-&ensp;
                                            {toFixedTrunc(
                                                transaction?.transactionDetails?.[0]
                                                    ?.toCryptoAmount,
                                                6,
                                            )}{' '}
                                            {getCurrencySymbol(
                                                transaction?.currency ||
                                                    transaction?.transactionDetails?.[0]
                                                        ?.toCryptoId,
                                            )}{' '}
                                        </p>
                                    )}
                                    {transaction?.type !== 'Exchange' && (
                                        <p className="jncTransactionsList__text !text-text t-right">
                                            {activeCurrencyPage === 'fiat' ? (
                                                <>
                                                    {toFixedTrunc(
                                                        transaction?.transactionDetails?.[0]
                                                            ?.fiatAmount,
                                                        2,
                                                    )}{' '}
                                                    {
                                                        transaction?.transactionDetails?.[0]
                                                            ?.fiatCurrency
                                                    }
                                                </>
                                            ) : (
                                                <>
                                                    {toFixedTrunc(
                                                        transaction?.transactionDetails?.[0]
                                                            ?.cryptoAmount ||
                                                            transaction?.transactionDetails?.[0]
                                                                ?.amount,
                                                        6,
                                                    )}{' '}
                                                    {transaction?.currency ||
                                                        transaction?.transactionDetails?.[0]
                                                            ?.currency}
                                                </>
                                            )}
                                        </p>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

TransactionListItem.propTypes = {
    data: PropTypes.object.isRequired,
};

export default TransactionListItem;
